import React from 'react'
import 'animate.css'
import Title from './Title'

export default function About() {
  return (
    <>
    <Title name={'My story'}/>
    <div className='about-container'>
        <p    className="about animate__animated animate__fadeIn" 
        style={{ '--animate-delay': '2s' }}>
        As a dedicated software engineer, I possess a deep passion for design and user experience. 
         Beneath my technical skills lies a fun-loving and outgoing personality, always eager to connect with others and share a laugh. While I acknowledge my shortcomings, I strive to rise above them, using positivity and determination to enhance both my personal and professional growth. Each challenge I encounter is an opportunity to 
        learn and improve, driving me to become a better version of myself every day.
        </p>
    </div>
    </>
  )
}
